module.exports = __webpack_public_path__ + "img/無障礙證書.9feadae5.jpg";